<template>
  <div>
    <template v-if="!_.isEmpty(draws_mn)">
      <f7-block-title>MIỀN NAM</f7-block-title>
      <f7-block inset>
        <div class="data-table kqxs sm bordered card">
          <table>
            <thead>
            <tr>
              <th class="text-align-center" style="width: 90px;"></th>
              <th class="text-align-center" v-for="(item, idx) in draws_mn" :key="idx">
                {{ channels[item.alias] | uppercase }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-align-center">GIẢI 8</td>
              <td class="text-align-center text-lg text-color-crimson" v-for="(item, idx) in draws_mn" :key="idx">
                {{ item['full'][0] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 7</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mn" :key="idx">{{ item['full'][1] }}</td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 6</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mn" :key="idx">
                {{ item['full'][2] }}<br/> {{ item['full'][3] }}<br/> {{ item['full'][4] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 5</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mn" :key="idx">
                {{ item['full'][5] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 4</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mn" :key="idx">
                {{ item['full'][6] }}<br/> {{ item['full'][7]  }}<br/> {{ item['full'][8]  }}<br/>
                {{ item['full'][9] }}<br/> {{ item['full'][10]  }}<br/> {{ item['full'][11]  }}<br/> {{ item['full'][12]  }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 3</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mn" :key="idx">
                {{ item['full'][13] }}<br/>{{ item['full'][14] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 2</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mn" :key="idx">
                {{ item['full'][15] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 1</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mn" :key="idx">
                {{ item['full'][16] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">ĐB</td>
              <td class="text-align-center text-lg text-color-crimson" v-for="(item, idx) in draws_mn" :key="idx">
                {{ item['full'][17] }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </f7-block>
    </template>
    <template v-if="!_.isEmpty(draws_mt)">
      <f7-block-title>MIỀN TRUNG</f7-block-title>
      <f7-block inset>
        <div class="data-table kqxs sm bordered card">
          <table>
            <thead>
            <tr>
              <th class="text-align-center" style="width: 90px;"></th>
              <th class="text-align-center" v-for="(item, idx) in draws_mt" :key="idx">
                {{ channels[item.alias] | uppercase }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-align-center">GIẢI 8</td>
              <td class="text-align-center text-lg text-color-crimson" v-for="(item, idx) in draws_mt" :key="idx">
                {{ item['full'][0] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 7</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mt" :key="idx">{{ item['full'][1] }}</td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 6</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mt" :key="idx">
                {{ item['full'][2] }}<br/> {{ item['full'][3] }}<br/> {{ item['full'][4] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 5</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mt" :key="idx">
                {{ item['full'][5] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 4</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mt" :key="idx">
                {{ item['full'][6]  }}<br/> {{ item['full'][7]  }}<br/> {{ item['full'][8]  }}<br/> {{ item['full'][9] }}<br/> {{ item['full'][10]  }}<br/> {{ item['full'][11]  }}<br/> {{ item['full'][12]  }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 3</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mt" :key="idx">
                {{ item['full'][13] }}<br/>{{ item['full'][14] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 2</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mt" :key="idx">
                {{ item['full'][15] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 1</td>
              <td class="text-align-center" v-for="(item, idx) in draws_mt" :key="idx">
                {{ item['full'][16] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">ĐB</td>
              <td class="text-align-center text-lg text-color-crimson" v-for="(item, idx) in draws_mt" :key="idx">
                {{ item['full'][17] }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </f7-block>
    </template>
    <template v-if="!_.isEmpty(draws.mb)">
      <f7-block-title>MIỀN BẮC</f7-block-title>
      <f7-block inset>
        <div class="data-table kqxs sm bordered card">
          <table>
            <tbody>
            <tr>
              <td class="text-align-center">ĐB</td>
              <td class="text-align-center text-lg text-color-crimson">{{ draws.mb.mb['full'][26] }}</td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 1</td>
              <td class="text-align-center">{{ draws.mb.mb['full'][25] }}</td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 2</td>
              <td class="text-align-center">
                {{ draws.mb.mb['full'][24] }} - {{ draws.mb.mb['full'][23] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 3</td>
              <td class="text-align-center">
                {{ draws.mb.mb['full'][22] }} - {{ draws.mb.mb['full'][21] }} - {{ draws.mb.mb['full'][20] }}<br/>
                {{ draws.mb.mb['full'][19] }} - {{ draws.mb.mb['full'][18] }} - {{ draws.mb.mb['full'][17] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 4</td>
              <td class="text-align-center">
                {{ draws.mb.mb['full'][16] }} - {{ draws.mb.mb['full'][15] }}<br/> {{ draws.mb.mb['full'][14] }} -
                {{ draws.mb.mb['full'][13] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 5</td>
              <td class="text-align-center">
                {{ draws.mb.mb['full'][12] }} - {{ draws.mb.mb['full'][11] }} - {{ draws.mb.mb['full'][10] }}<br/>
                {{ draws.mb.mb['full'][9] }} - {{ draws.mb.mb['full'][8] }} - {{ draws.mb.mb['full'][7] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 6</td>
              <td class="text-align-center">
                {{ draws.mb.mb['full'][6] }} - {{ draws.mb.mb['full'][5] }} - {{ draws.mb.mb['full'][4] }}
              </td>
            </tr>
            <tr>
              <td class="text-align-center">GIẢI 7</td>
              <td class="text-align-center text-lg text-color-crimson">
                {{ draws.mb.mb['full'][3] }} - {{ draws.mb.mb['full'][2] }} - {{ draws.mb.mb['full'][1] }} -
                {{ draws.mb.mb['full'][0] }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </f7-block>
    </template>
    <f7-block-title class="text-align-center text-color-crimson" v-if="_.isEmpty(draws.mn) && _.isEmpty(draws.mt) && _.isEmpty(draws.mb)">
      CHƯA CÓ KQXS
    </f7-block-title>
    <template v-else>
      <f7-block-title class="text-align-center text-color-crimson" v-if="_.isEmpty(draws.mn)">
        CHƯA CÓ KQXS MIỀN NAM
      </f7-block-title>
      <f7-block-title class="text-align-center text-color-crimson" v-if="_.isEmpty(draws.mt)">
        CHƯA CÓ KQXS MIỀN TRUNG
      </f7-block-title>
      <f7-block-title class="text-align-center text-color-crimson" v-if="_.isEmpty(draws.mb)">
        CHƯA CÓ KQXS MIỀN BẮC
      </f7-block-title>
    </template>
  </div>
</template>
<script>
import {mapState} from 'vuex';

export default {
  computed  :{
    ...mapState(['channels']),
    draws_mn(){
      return this._.orderBy(this.draws.mn, ['index'], ['asc']);
    },
    draws_mt(){
      return this._.orderBy(this.draws.mt, ['index'], ['asc']);
    },
    draws_mb(){
      return this._.orderBy(this.draws.mb, ['index'], ['asc']);
    }
  },
  props     :{
    draws:Object
  },
};
</script>
<style scoped>
.data-table.kqxs tbody td {
  padding : 5px;
  height  : auto;
}
.data-table.kqxs tbody tr:nth-child(even) {
  /*background : #F0F0F0;*/
}
.text-lg {
  font-size : 18px
}
</style>
